import { Box, Flex, Text } from '@mantine/core';
import { IconArrowDown, IconArrowsSort, IconArrowUp } from '@tabler/icons-react';
import classes from './PriorityOrderBar.module.css';

const PriorityOrderBar = () => (
  <Flex align="center" gap="xs" mb="sm" px="sm" py={6} className={classes.bar}>
    <IconArrowsSort size={16} color="var(--mantine-color-dimmed)" />
    <Text size="sm" c="dimmed">
      Ordered by priority — drag to rearrange
    </Text>
    <Box className={classes.spacer} />
    <Flex align="center" gap={4}>
      <IconArrowUp size={14} color="var(--mantine-color-dimmed)" />
      <Text size="xs" c="dimmed">Higher priority</Text>
    </Flex>
    <Flex align="center" gap={4} ml="sm">
      <IconArrowDown size={14} color="var(--mantine-color-dimmed)" />
      <Text size="xs" c="dimmed">Lower priority</Text>
    </Flex>
  </Flex>
);

export default PriorityOrderBar;
